<template>
    <div>
        <div class="text-center text-l-size margin-top font-weight-bolder text-default-color">
            历年分数查询
        </div>
        <div>
            <el-table class="margin-medium-top table"
                      :cell-style="{'text-align':'center'}"
                      :data="tableData"
                      border :span-method="objectSpanMethod"
                      :header-cell-style="headerCellStyle"
                      style="width: 100%"
                      v-loading="loadingTable">
                <el-table-column prop="year" label="年份"></el-table-column>
                <el-table-column prop="phaseName" label="批次"></el-table-column>
                <el-table-column prop="wenScoreLine" label="文科"></el-table-column>
                <el-table-column prop="liScoreLine" label="理科"></el-table-column>
            </el-table>
        </div>

        <!-- 志愿填报 -->
<!--        <div>-->
<!--            <voluteerApply></voluteerApply>-->
<!--        </div>-->
    </div>
</template>
<script>
    import {yearGaoKaoScore} from "../../config";
    import  voluteerApply from './volunteerApply/volunteerApply.vue'
    import  List from './volunteerApply/volunteerApplyList/volunteerApplyList'
    export default {
        name: "scoreQueryOTyear",
        data(){
            return{
                tableData:[],
                loadingTable:false,
                headerCellStyle: {
                    background: 'rgb(232 248 255)',
                    color: '#666666',
                    fontWeight: 'bolder',
                    textAlign: 'center',
                },
                spanArr:[]
            }
        },
        components: {
            voluteerApply,
            List
        },
        mounted(){
            this.searchCalendarYearScore();
        },
        methods:{
            //查出历年分数线
            async searchCalendarYearScore(){
                this.loadingTable=true;
               let result=await yearGaoKaoScore();
               if(result.status){
                   this.spanArr = [];
                   let contactDot = 0;
                   result.data.scores.forEach((item,index) => {
                       item.index = index;
                       if (index === 0) {
                           this.spanArr.push(1);
                       } else {
                           if (item.year ===  result.data.scores[index - 1].year) {
                               this.spanArr[contactDot] += 1;
                               this.spanArr.push(0);
                           } else {
                               this.spanArr.push(1);
                               contactDot = index;
                           }
                       }
                   })
                   this.loadingTable=false;
                   this.tableData=result.data.scores;
               }else{
                   this.loadingTable=false;
               }
            },
            objectSpanMethod({ row, column, rowIndex, columnIndex }){
                if(columnIndex === 0){
                    const _row = this.spanArr[rowIndex];
                    const _col = _row>0?1:0;
                    return{
                        rowspan:_row,
                        colspan:_col
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
